const App = {
	SetBackground: () => {
		$('[setBackground]').each(function () {
			var background = $(this).attr('setBackground')
			$(this).css({
				"background-image": "url(" + background + ")",
				"background-size": "cover",
				"background-position": "center center"
			})
		})
		$('[setBackgroundRepeat]').each(function () {
			var background = $(this).attr('setBackgroundRepeat')
			$(this).css({
				"background-image": "url(" + background + ")",
				"background-repeat": "repeat"
			})
		})
	},
	EqualHeightElement: el => {
		let height = 0;
		let thisHeight = 0;
		$(el).each(function () {
			thisHeight = $(this).height();
			if (thisHeight > height) {
				height = thisHeight;
			}
		});
		$(el).height(height)
	},
	InitLazyLoad: () => {
		return new LazyLoad({
			elements_selector: ".lazy"
		});
	},
	ScrollTo: y => {
		$('html, body').animate({
			scrollTop: y
		}, 1000)
	},
	Init: () => {
		App.SetBackground()
		App.InitLazyLoad()
	}
}

function InitSlider() {
	let customerSlide = new Swiper('.list-customer .swiper-container', {
		slidesPerView: 6,
		slidesPerColumn: 2,
		spaceBetween: 30,
		slidesPerGroup: 6,
		grabCursor: true,
		breakpoints: {
			576: {
				slidesPerView: 2,
				slidesPerGroup: 2,
			},
			768: {
				slidesPerView: 3,
				slidesPerGroup: 3,
			},
			1024: {
				slidesPerView: 4,
				slidesPerGroup: 4,
			},
			1200: {
				slidesPerView: 5,
				slidesPerGroup: 5,
			}
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			renderBullet: function (index, className) {
				return '<span class="' + className + '">' + (index + 1) + '</span>';
			}
		},
	})
	let homeBannerSlide = new Swiper('.pm3-home-banner .swiper-container', {
		freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		navigation: {
			nextEl: '.pm3-home-banner .swiper-next',
			prevEl: '.pm3-home-banner .swiper-prev',
		},
	});
}
$(document).ready(function () {
	imageMap()
	App.Init()
	App.EqualHeightElement('.pm3-abouts-2 .map-wrapper .item')
	tabOUTSTANDING()
	toggleSearch()
	togglenav()
	mappingInit()
	height()
	InitSlider()
	tab()
	slide()
	// buttonScroll()
	toggleslide()
	toogleMenuNav()
	// buttonScroll()
	AboutNav.init();
	shareNewsDetail();
	imgmap();
	countUp();
	activeMenu();
})

//toggleSeachr
function toggleSearch() {
	$('.header-wrapper .header-bottom .wrapper .searchtoggle').on('click', function () {
		$('.header-wrapper .header-bottom .wrapper .searchbox').toggleClass('active')
	})
}
//nav
function togglenav() {
	$('.button-toggle').on('click', function () {
		$(this).toggleClass('active')
		$('.nav-mobile').toggleClass('active')
		$('.back-drop').toggleClass('active')
	});
	$('.back-drop').on('click', function () {
		$(this).removeClass('active')
		$('.nav-mobile').removeClass('active')
		$('.button-toggle').removeClass('active')
	})
}

function height() {
	let e = $('header').outerHeight()
	$('header .nav-mobile').css({
		'height': 'calc(100% - ' + (e) + 'px )',
		'top': (e) + 'px',
	})
	$('header .back-drop').css({
		'height': 'calc(100% - ' + (e) + 'px )',
		'top': (e) + 'px',
	})
	$('main').css({
		'padding-top': (e) + 'px'
	})
}

function mappingInit() {
	var searchbox = new MappingListener({
		selector: ".header-wrapper .searchbox",
		mobileWrapper: ".nav-mobile",
		mobileMethod: "appendTo",
		desktopWrapper: ".header-wrapper .wrapper .searchtoggle",
		desktopMethod: "insertAfter",
		breakpoint: 1200,
	}).watch();

	var navmenu = new MappingListener({
		selector: ".header-wrapper .nav-menu",
		mobileWrapper: ".nav-mobile",
		mobileMethod: "appendTo",
		desktopWrapper: ".header-wrapper .wrapper .logo",
		desktopMethod: "insertAfter",
		breakpoint: 1200,
	}).watch();

}

function toogleMenuNav() {
	var header = $('header').height()
	var mainNav = $('.main-nav')
	var buttonToggle = $('.main-nav .category-show')
	var menuToogle = $('.main-nav .list-media')
	buttonToggle.on('click', function () {
		$(this).toggleClass('active')
		menuToogle.slideToggle()
	})
	if ($(window).width() < 1024) {
		mainNav.css('top', header)
	}
}

function tab() {
	$('.tabs').tabslet({});
}
//slider
function slide() {
	var aboutAwads = new Swiper('.awads .swiper-container', {
		spaceBetween: 10,
		slidesPerView: 4,
		freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		navigation: {
			nextEl: '.awads .swiper-next',
			prevEl: '.awads .swiper-prev',
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 10
			},
			576: {
				slidesPerView: 2,
				spaceBetween: 10
			},
			375: {
				slidesPerView: 1,
				spaceBetween: 10
			},
		},
	});
}

// function buttonScroll() {
//     $(".abouts .tab ul li .button1").click(function() {
//         $('html, body').animate({
//             scrollTop: $(".tab-1").offset().top
//         }, 2000);
//     });

// }
// Active tab đầu tiên khi trang web được chạy
// activeTab($('.tab li:first-child'))

//slidetoggle
function toggleslide() {
	var toggleFaq = $('.pre-post .list .list-operation .title')
	toggleFaq.on('click', function () {
		toggleFaq.parent('.list-operation').find('.content').slideUp(500)
		if ($(this).hasClass('active')) {
			$(this).removeClass('active')
			$(this).parent('.list-operation').find('.content').slideUp(500)
		} else {
			toggleFaq.removeClass('active')
			$(this).addClass('active')
			$(this).parent('.list-operation').find('.content').slideDown(500)
		}
	})
}
let AboutNav = {
	clickToScroll: () => {
		$('.pm3-about-nav .nav-about li').on('click', function () {
			$('.pm3-about-nav .nav-about li').removeClass('active')
			$(this).addClass('active')
			let active = $(this).attr('data-section')
			let offset = $('section#section-' + active).offset().top - $('header').height()
			// console.log(offset)
			$("html, body").animate({
				scrollTop: offset
			}, 1000);
		})
	},
	checkMenuScroll: () => {
		var scrollTop = $(window).scrollTop(),
			header = $('header').outerHeight(),
			offset = $('.pm3-about-nav').offset().top
		if (((offset - header) - scrollTop) <= 0) {
			$('.pm3-about-nav').addClass('active').css({
				"top": (header - 1) + "px"
			})
		} else {
			$('.pm3-about-nav').removeClass('active').removeAttr('style')
		}
	},
	scrollActive: () => {
		$('.pm3-about-nav .nav-about li').each(function () {
			let active = $(this).attr('data-section')
			let offset = $('section#section-' + active).offset().top - $('header').height() - 50
			if ($(window).scrollTop() >= offset) {
				$('.pm3-about-nav .nav-about li').removeClass('active')
				$(this).addClass('active');
			}
		});
	},
	showNav: () => {
		$('.pm3-about-nav .main-nav .category-show').on('click', function () {
			// $('.all-product-detail-nav .nav-mobile').toggleClass('active')
			$('.pm3-about-nav .nav-about').slideToggle()
		})
	},
	init: () => {
		if ($('.pm3-about-nav').length > 0) {
			// console.log(2)
			AboutNav.scrollActive()
			AboutNav.clickToScroll()
		}
		AboutNav.showNav()
	}
}
$(document).on('scroll', function () {
	if ($('.pm3-about-nav').length > 0) {
		AboutNav.scrollActive()
		AboutNav.checkMenuScroll()
	};
});

function shareNewsDetail() {
	$("#share-socical").jsSocials({
		showLabel: false,
		showCount: false,
		shareIn: "popup",
		shares: [{
				share: "facebook",
				logo: "fab fa-facebook-f"
			},
			{
				share: "twitter",
				logo: "fab fa-twitter"
			},
			// {
			//     share: "linkedin",
			//     label: "Share",
			//     logo: "fab fa-linkedin"
			// }
		]
	});
}

function imageMap() {
	$('#imageMap').maphilight({
		fillColor: '82ba41',
		fillOpacity: 0.7,
		stroke: false,
		groupBy: 'group'
	})

	$('.image-map area').each(function () {
		let index = $(this).data('index')
		$(this).qtip({
			content: {
				text: $(".tooltip-container .map-tooltip[data-index='" + index + "']").clone()
			},
			position: {
				container: $('div.image-map'),
				my: 'bottom center',
				at: 'top center',
			}
		})
	});
	$('img[usemap]').rwdImageMaps()
}

function tabOUTSTANDING() {
	var tabBig = $('.pm3-home-3 .list-outstanding li')
	var contentBig = $('.pm3-home-3 .main-outstanding')
	tabBig.each(function () {
		$(this).on('click', function () {
			tabBig.removeClass('active')
			$(this).addClass('active')
			var tabBigAttr = $(this).attr('data-outstanding')
			contentBig.removeClass('active')
			$('.pm3-home-3 .main-outstanding[content-outstanding=' + tabBigAttr + ']').addClass('active')
		})
	})

	var tabChild = $('.outstanding-item')
	var contentChild = $('.box-outstanding-content')
	tabChild.each(function () {
		$(this).on('click', function () {
			tabChild.removeClass('active')
			if ($(this).hasClass('active')) {
				$(this).removeClass('active')
				$('.box-outstanding-content[data-outstanding-content=' + tabChildAttr + ']').removeClass('active').slideUp()
			} else {
				$(this).addClass('active')
				var tabChildAttr = $(this).attr('data-outstanding-item')
				contentChild.removeClass('active').slideUp()
				$('.box-outstanding-content[data-outstanding-content=' + tabChildAttr + ']').toggleClass('active').slideDown()
			}
		})
	})
	$('.box-outstanding-content .btn-close').on('click', function () {
		tabChild.removeClass('active')
		$(this).parents('.box-outstanding-content').slideUp()
	})
}



function imgmap() {
	//Map high light
	// $('.image-map-wrapper img[usemap]').maphilight();
	// $('.image-map-wrapper img[usemap]').rwdImageMaps();

	//map hight light text
	$('.tooltip').tooltipster({
		contentCloning: true,
		maxWidth: 320,
		minWidth: 280,

	});
}

function countUp() {
	$('.count-up-number').countUp({
		'time': 2000,
		'delay': 10
	});
}

function activeMenu() {
	var url = window.location.pathname,
		urlRegExp = new RegExp(url.replace(/\/$/, '') + "$")
	$('.nav-menu ul li a').each(function () {
		if (urlRegExp.test(this.href.replace(/\/$/, ''))) {
			$(this).addClass('active');
		}
	})
}

// $(document).on("click", ".pm3-home-banner video", function (e) {
// 	var video = $(this).get(0);
// 	if (video.paused === false) {
// 		video.pause();
// 		$(this)
// 			.parent()
// 			.find(".icon-video")
// 			.fadeIn();
// 		$(this)
// 			.parents(".pm3-home-banner")
// 			.find(".swiper-caption")
// 			.fadeIn();
// 	} else {
// 		video.play();
// 		$(this)
// 			.parent()
// 			.find(".icon-video")
// 			.fadeOut();
// 		$(this)
// 			.parents(".pm3-home-banner")
// 			.find(".swiper-caption")
// 			.fadeOut();
// 	}
// 	return false;
// });
